"use client";

import { useState, useLayoutEffect } from "react";

export function useWindowSize(
  initialWidth = Infinity,
  initialHeight = Infinity
) {
  const [windowSize, setWindowSize] = useState({
    width: initialWidth,
    height: initialHeight,
  });

  useLayoutEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return {
    ...windowSize,
    isSmallScreen: windowSize.width < 768,
    isMediumScreen: windowSize.width >= 768 && windowSize.width < 1280,
    isLargeScreen: windowSize.width >= 1280,
    aboveMediumScreen: windowSize.width >= 768,
    aboveLargeScreen: windowSize.width >= 1280,
  };
}
